import springApi from '../../services/springApi'

export const getCheckins = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/checkins', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeCheckin = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/checkins', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateCheckin = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/checkins/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteCheckin = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/checkins/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)